import { PrimaryControlsStripBack } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import type { ReactNode } from "react";

/** Keeps character panels opened from the map inside the map's own stack, over the map. */
export function MapMorphemeLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <PrimaryControlsStripBack appShellPlacement="toolbar" fallbackHref="/(nav)/(app)/learn/map">
        Map
      </PrimaryControlsStripBack>
      {children}
    </>
  );
}
